import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  position:relative;
  height:${({ noHeight }) => noHeight ? '100%' : '100vh'};
  ${({ top }) => top && css`
    padding-top: calc(70px + (130 - 70) * ((100vw - 375px) / (1920 - 375)));
  `}
  ${({ bottom }) => bottom && css`
    padding-bottom: calc(70px + (130 - 70) * ((100vw - 375px) / (1920 - 375)));
  `}
  ${({ both }) => both && css`
    padding-top: calc(70px + (130 - 70) * ((100vw - 375px) / (1920 - 375)));
    padding-bottom: calc(70px + (130 - 70) * ((100vw - 375px) / (1920 - 375)));
  `}
  ${({ bothInitial }) => bothInitial && css`
    padding-top: calc(100px + (190 - 100) * ((100vw - 375px) / (1920 - 375)));
    padding-bottom: calc(70px + (130 - 70) * ((100vw - 375px) / (1920 - 375)));
  `}
  ${({ topInitial }) => topInitial && css`
    padding-top: calc(100px + (190 - 100) * ((100vw - 375px) / (1920 - 375)));
  `}
  box-sizing: border-box;

  ${({ full }) => full && css`
    min-height:100vh;
    max-height:100%;
  `}
`;

export default Wrapper;